import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Moment from 'moment';
import { LEAD_ACCEPTANCE } from '_constants';
import _ from 'lodash';

import dateTimeIcon from '../../assets/img/lead-date-and-time-icon.svg';
import sellerIcon from '../../assets/img/lead-type-seller-icon.svg';
import buyerIcon from '../../assets/img/lead-type-buyer-icon.svg';
import locationIcon from '../../assets/img/location-icon.svg';
import connectIcon from '../../assets/img/lead-connect-icon.svg';

const LeadAcceptanceBody = ({ ...props }) => {
  const { leadAcceptance, onClickHandler } = props;

  const leadType = _.get(leadAcceptance, 'opportunity.type', null);
  const contact = _.get(leadAcceptance, 'contact', {});
  const contactAddress = _.get(leadAcceptance, 'contact.addresses', []);
  const opportunity = _.get(leadAcceptance, 'opportunity', {});
  const appointment = _.get(leadAcceptance, 'appointment', {});
  const areasOfInterest = _.get(leadAcceptance, 'opportunity.areasOfInterest', []);
  const propertyAddress = _.get(leadAcceptance, 'opportunity.contactProperty.property.address', null);

  function getLeadIcon () {
    return leadType === 'Buyer' ? buyerIcon : sellerIcon || '';
  }

  function getLocation () {
    const location = [];
    (areasOfInterest || []).map(address => {
      if (!address.type.includes('MLS') && location.length <= 0) {
        location.push(address.value);
      }
    });
    const buyerLocation = (location.length > 0) ? location[0] : addressConcat(propertyAddress || {});
    const sellerLocation = (location.length > 0) ? location[0] : (propertyAddress == null) ? addressConcat(contactAddress[0] || {}) : addressConcat(propertyAddress || {});
    return leadType === 'Buyer' ? buyerLocation : sellerLocation;
  }

  const testValue = (value) => {
    if (typeof value === 'undefined') {
      return '';
    } else {
      return value;
    }
  };

  const addressConcat = (address) => {
    let addComma = '';

    if (!!address.city && !!address.stateOrProvince) {
      addComma = ',';
    }

    return `${testValue(address.city)}${addComma} ${testValue(address.stateOrProvince)} ${testValue(address.postalCode)}`;
  };

  function getLeadSource () {
    return (opportunity.leadSource) || (contact.leadSources && contact.leadSources.length > 0 && contact.leadSources[0].leadSource) || 'Source';
  }

  function getLeadSubSource () {
    return (opportunity.leadSubSource) || (contact.leadSources && contact.leadSources.length > 0 && contact.leadSources[0].subLeadSource) || 'Sub Source';
  }

  return (
    <div className='lead-notification-body'>
      <div className='appointment-card-container'>
        <div className='appointment-card'>
          <div className='lead-section-container border-section-bottom'>
            <div className='appointment-card-icon'>
              <img src={dateTimeIcon} />
            </div>
            <div className='appointment-section-details'>
              <div className='lead-notification-header'>SCHEDULED APPOINTMENT TIME</div>
              <div className='lead-notification-text'>
                <b>
                  {Moment(appointment.timestampStart).format('dddd, MMMM D [at] hh:mm A')}
                </b>
              </div>
            </div>
          </div>

          <div className='lead-section-container border-section-bottom'>
            <div className='appointment-card-icon'>
              <img src={getLeadIcon()} />
            </div>
            <div className='appointment-section-details'>
              <div className='lead-notification-header'>LEAD TYPE</div>
              <div className='lead-notification-text'>
                { leadType }
              </div>
            </div>
          </div>

          <div className='lead-section-container border-section-bottom'>
            <div className='appointment-card-icon'><img src={locationIcon} /></div>
            <div className='appointment-section-details'>
              <div className='lead-notification-header'>LOCATION</div>
              <div className='lead-notification-text'>{ getLocation() }</div>
            </div>
          </div>

          <div className='lead-source-container'>
            <span>
              <img src={connectIcon} />
            </span><span className='ml-2'>{getLeadSource() + '/' + getLeadSubSource()}</span>
          </div>
        </div>

      </div>
      <div className='w-90 d-flex row text-center align-items-center justify-content-center lead-message-container p-4'>
        <span className='lead-message-container'>{LEAD_ACCEPTANCE.DISCLAIMER}</span>
      </div>
      <div className='lead-acceptance-bottom-container'>
        <button
          className='lead-acceptance-btn'
          onClick={() => onClickHandler()}>
          Accept Lead
        </button>
      </div>
    </div>
  );
};

LeadAcceptanceBody.propTypes = {
  leadAcceptance: PropTypes.object.isRequired,
  onClickHandler: PropTypes.func.isRequired
};

export default connect((state) => { return {}; })(withRouter(LeadAcceptanceBody));
